import axios from 'axios';

export default {
  updateUserInfo(state, payload) {
    state.user = payload;
    state.username = payload.Username;
  },

  updateUserToken(state, token) {
    state.token = token.access;
    state.refreshToken = token.refresh;
    axios.defaults.headers = { Authorization: token.access };
  },

  updateUserId(state, id) {
    state.userId = id;
  },

  authLogout(state) {
    state.token = '';
    state.userId = '';
    axios.defaults.headers['Authorization'] = '';
    state.sendedNewComer = [];
    state.router.push({ name: 'login' });
  },

  updateTagList(state, data) {
    state.tagList = data;
  },

  updateTagListLoading(state, status) {
    state.tagListLoading = status;
  },

  setUpdateDialogItem(state, status) {
    state.updateDialogItem = status;
  },

  updateFeedItems(state, data) {
    state.feedItems = data;
  },

  setFilterGroupId(state, data) {
    state.filterGroupId = data.groupId;
    state.filterGroupName = data.groupName;
  },

  setFilterState(state, data) {
    state.myRegion = data.myRegion || false;
    state.myDivision = data.myDivision || false;
  },

  setSendedUser(state, data) {
    state[data.sendKey] = data.value;
  },

  updateNotificationsData(state, data) {
    state.notificationItems = data;
  },

  updateTotalUnSeenNotification(state, data) {
    state.totalUnSeenNotification = data;
  },

  readNotifications(state, id) {
    state.totalUnSeenNotification--;
    state.notificationItems.find((i) => i.Id === id).IsSeen = true;
  },

  readAllNotification(state) {
    state.totalUnSeenNotification = 0;
    state.notificationItems.map((i) => (i.IsSeen = true));
  },

  setRemoteConfig(state, data) {
    state.videoViewsRate = data.videoViewsRate;
  },
};
